import Config from '../config';
import subject from '../auth';

import Channel from '../utils/channel';

export default connect;

function connect(baseUrl) {

    const conn = subject.then( ({ token }) => {
        return new Promise( (resolve, reject) => {
            let hostPort = Config.wsHost();
            if (!hostPort) {
                const m = location.href.match( 'http(s?)://([^:/]+):?([0-9]+)?' ),
                    scheme = m[1] ? 'wss' : 'ws',
                    host = m[2],
                    port = m[3] || '';

                hostPort = `${scheme}://${host}${port ? ':' : ''}${port}`;
            }

            const url = `${hostPort}${Config.wsBase()}${baseUrl}${~baseUrl.indexOf( '?' ) ? '&' : '?'}token=${token}`;
            const socket = new WebSocket( url );
    
            socket.onopen = () => resolve( socket );
            socket.onerror = e => {
                console.error( e );
                reject( e );
            }
        } )
    } );

    conn.catch( e => console.log( `${baseUrl}: connection attempt failed` ) );

    return conn.then( socket => {

        // create and run pinger
        const pingInterval = setInterval( () => socket.send( '{}' ), 15000 );

        // todo: delete channel when closing
        return new Channel( (writeFn, closeFn) => {
            socket.onmessage = message =>
                writeFn( JSON.parse( message.data ) );

            socket.onclose = e => {
                if (e.wasClean)
                    console.log( `${baseUrl}: connection closed` );
                else
                    // for example, server process killed
                    console.error( `${baseUrl}: connection has been broken` ); 

                clearInterval( pingInterval );

                if (closeFn)
                    closeFn();
            };
        } );
    } );

}


// WEBPACK FOOTER //
// ./src/js/http/ws.js